import React, { Component, Children } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import qs from 'qs';

import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import isNumber from '../../utils/numbers/isNumber';

import List from './List';

export default class CompanyDocuments extends Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static List = List

  constructor(props) {
    super(props);
    this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: [],
    };
  }
  componentDidMount() {
    const { query } = this.props.location;
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.fetchCompanyDocuments(query);
  }
  componentWillReceiveProps(nextProps) {
    const { query } = nextProps.location;
    this.fetchCompanyDocuments(query);
  }
  setCompanyDocuments(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async fetchCompanyDocuments(q) {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      res = await store.dispatch(fetchM(`/company_documents/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      await this.setCompanyDocuments(data);
      if (this.state.data.length < 1 && query.page > 1) {
        query.page = 1;
        store.dispatch(replace(`/company_documents/?${qs.stringify(query)}`));
      }
      // handle token.. etc
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  renderChild() {
    return Children.map(this.props.children, child => (
      React.cloneElement(child, {
        token: this.state.token,
        count: this.state.count,
        limit: this.state.limit,
        offset: this.state.offset,
        loading: this.state.loading,
        data: this.state.data,
      })
    ));
  }
  render() {
    return (
      <div>
        {this.renderChild()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CompanyDocuments/CompanyDocuments.jsx